<ion-card>
    <ion-fab vertical="center" horizontal="end" >
        <ion-fab-button (click)="openModalSearchContact()" size="small" color="light">
            <ion-icon name="create"></ion-icon>
        </ion-fab-button>
    </ion-fab>

    <ion-card-content *ngIf="!document.signatureContact.name" (click)="openModalSearchContact()">
        <ion-label>Collect signature...</ion-label>
    </ion-card-content>
    <ion-card-content *ngIf="document.signatureContact.name">
        <ion-row>
            <ion-col size="9">
                {{document.signatureContact.name}}
            </ion-col>
        </ion-row>

        <ion-row>
            <ion-col size="5">
                {{document.signatureContact.phone}}
            </ion-col>
            <ion-col size="5" *ngIf="document.signatureContact.phone">
                <ion-chip (click)="callContact.callContact(document.signatureContact.phone)" class="ion-float-right" color="success">
                    Call
                    <ion-icon name="call"></ion-icon>
                </ion-chip>
            </ion-col>
        </ion-row>
        <ion-img *ngIf="document.signature !== null" [src]="document.signature">
        </ion-img>
    </ion-card-content>

</ion-card>
